import React from 'react'
import {Redirect, Route} from 'react-router'
import { KEYS } from '../constants/keysStorage'
import {ROLES} from '../constants/roles'
import {useAutorizado} from '../components/Autorizado/Autorizado'

interface IParent {
  component: React.ComponentType<any>
  roles?: Array<ROLES>
  [ket: string]: any
}

const PrivateRoute = ({component: Component, roles, ...rest}: IParent) => {
  let auth = localStorage.getItem(KEYS.ID_CLIENT)
  const autorizado = useAutorizado(roles ?? [])
  if (!auth) return <Route {...rest}><Redirect to='/' /></Route>
  if (!autorizado) return <Route {...rest}><Redirect to='/home' /></Route>
  return <Route {...rest}><Component /></Route>
}

export default PrivateRoute
